import React, { useState } from 'react';
import { Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';

import { AddButton } from '../../../components/common/button/CustomButtons';
import ChildHeader from '../../../components/ui/ChildHeader';
import { SearchFilterContainer } from '../../../assets/styles/layout/searchFilter.styled';
import FilterBy from '../../../components/common/FilterBy';
import { SearchBar } from '../../../components/common/SearchBar';
import { CustomPagination, TableCustom } from '../../../components/common';
import useDebounce from '../../../hooks/useDebounce';
import {
  CustomIconButton,
  EditIconButton,
} from '../../../components/common/button/CustomIconButton';

import { useQuery } from '../../../hooks/UseQuery';
import useConfirm from '../../../components/common/useConfirm';
import { IData } from './interface';
import { MdUpdate } from 'react-icons/md';
import InputMuiCustom from '../../../components/common/inputs/InputMuiCustom';
import useFocus from '../../../hooks/useFocus';

const tableHeaderObj = [
  [
    { text: 'S.No.', rowspan: 1, colspan: 1 },
    { text: 'Customer Name', rowspan: 1, colspan: 1 },
    { text: 'Part Code', rowspan: 1, colspan: 1 },
    { text: 'Part Name', rowspan: 1, colspan: 1 },
    { text: 'Sale Rate', rowspan: 1, colspan: 1 },
  ],
];

const filterOptions = [
  { value: 'part_number', name: 'A-Z' },
  { value: 'createdAt', name: 'Most Recent First' },
  { value: 'createdAt_old', name: 'Oldest First' },
];

const List = () => {
  const [data, setData] = useState<IData[]>([]);
  const [isEdible, setIsEdible] = useState<boolean[]>([]);
  const [render, setRender] = useState(false);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);
  const search = useQuery('search') || '';
  const filter = useQuery('filter') || 'createdAt';
  const page = useQuery('page') || 1;
  const [inputRef, setInputFocus] = useFocus();

  const [DialogUpdate, confirmUpdate] = useConfirm(
    'Update Sales Rate',
    'Are you sure you want to Update this?'
  );

  const fetchData = async () => {
    const res = await axios
      .get(
        `/api/addPartRoute/byDocType/publish?page=${page}&sortBy=${
          filter || 'part_number'
        }&search=${search}&perPage=${10}`
      )
      .catch((err) => {
        console.log(err);
      });
    setIsEdible(Array(res?.data?.result.length).fill(false));
    setData(res?.data?.result);
    setPerPage(res?.data?.perPage);
    setTotalPages(res?.data?.pages);
  };

  useDebounce(fetchData, 500, [page, search, filter]);

  const handleEdible = (indexEdit: number) => {
    setIsEdible((prev) => prev.map((_, i) => i === indexEdit));
  };

  const handleUpdate = async (itemId: any, salesRate: any) => {
    const ans = await confirmUpdate();
    if (!ans) return;
    await axios
      .patch(`/api/salePlanningRoute/${itemId}`, { sale_rate: salesRate })
      .then((res) => {
        window.alert('successfully updated');
        handleEdible(data.length + 1);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <ChildHeader text="SALE RATE LIST"></ChildHeader>
      <SearchFilterContainer filter={true}>
        <SearchBar label="Search" />
        <FilterBy options={filterOptions} />
      </SearchFilterContainer>
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {data &&
            data.map((item: IData, index: number) => (
              <React.Fragment key={item._id}>
                <TableRow
                  style={{
                    background: `${(index + 1) % 2 === 0 ? '#f8f9fa' : '#fff'}`,
                    transition: 'all .15s ease',
                    transform: `${
                      isEdible[index] ? 'scale(1.01)' : 'scale(1)'
                    }`,
                    boxShadow: `${
                      isEdible[index] ? '0 2px 4px rgba(0, 0, 0, 0.1)' : 'none'
                    }`,
                  }}
                >
                  <TableCell align="center">
                    {perPage * (+page - 1) + index + 1}
                  </TableCell>
                  <TableCell align="center">
                    {item?.customer_id &&
                      typeof item?.customer_id !== 'string' &&
                      item.customer_id.customer_name}
                  </TableCell>
                  <TableCell align="center">{item?.part_number}</TableCell>
                  <TableCell align="center">{item?.part_name}</TableCell>

                  <TableCell>
                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                      <InputMuiCustom
                        type="number"
                        variant="outlined"
                        name="sale_rate"
                        placeholder=""
                        onBlur={(e) => {
                          item.sale_rate = +e.target.value;
                        }}
                        sx={{ width: '100px' }}
                        defaultValue={item.sale_rate || null}
                        InputProps={{
                          readOnly: !isEdible[index],
                        }}
                      />
                      <EditIconButton
                        tooltipTitle="EDIT Sale Rate"
                        onClick={() => {
                          handleEdible(index);
                        }}
                        styleIcon={{
                          color: `${isEdible[index] ? '#e67700' : '#343a40'}`,
                        }}
                      />
                      <CustomIconButton
                        sx={{ p: 0, ml: 1 }}
                        tooltipTitle="Update"
                        onClick={() => handleUpdate(item?._id, item?.sale_rate)}
                      >
                        <MdUpdate color="#2f9e44" size={'2.5rem'} />
                      </CustomIconButton>
                    </Stack>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>
      <CustomPagination totalPage={totalPages} />
      <DialogUpdate isSubmitContent={false} />
    </>
  );
};

export default List;
